import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';
import StateSitemap from 'sly/sitemap/components/StateSitemap';

export const getServerSideProps = async ({ params }) => {
  const { api, store } = createApiClient(apiEndpoints);

  const requestParams = { state: params.state };
  await Promise.allSettled([
    store.dispatch(
      api.getSitemapState.asAction(requestParams, {
        signal: AbortSignal.timeout(20000),
      })
    ),
    store.dispatch(
      api.getSitemapStateCounties.asAction(requestParams, {
        signal: AbortSignal.timeout(20000),
      })
    ),
    store.dispatch(
      api.getSitemapCommunitiesByState.asAction(requestParams, {
        signal: AbortSignal.timeout(20000),
      })
    ),
  ]);

  return {
    props: { initialApiState: store.getState() },
  };
};

export default StateSitemap;
